import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css' // 確保路徑正確
import PrimeVue from "primevue/config";
import Noir from './presets/Noir';
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import ToastService from 'primevue/toastservice';

const pinia = createPinia()
const app = createApp(App);

pinia.use(piniaPluginPersistedstate)
app.use(pinia)

app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: false,
        }
    }
});
app.use(ToastService);


app.use(router).mount('#app');